import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { MonoTypeOperatorFunction, Observable, throwError } from 'rxjs';
import { ModalHelper } from './modal-helper.service';

@Injectable()
export class ErrorTranslatorService {

  constructor(private modalHelper: ModalHelper) { }

  showErrors<T>(errorTitle: string, errorDescription: string): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) => {
      return source.pipe(
        catchError((error, caught) => {
          const errorReason = this.getErrorReasonFromHttpStatus(error);
          const errorDetail = this.getDetailedError(error);
          console.error(`${errorTitle}: ${errorDescription} ${errorReason} ${errorDetail}`);
          console.error(error);
          this.modalHelper.openAlert({
            title: errorTitle,
            message: `${errorDescription} ${errorReason}`,
            closeButton: 'Ok'
          });
          return throwError(error);
        })
      );
    };
  }

  getDetailedError(error: any): string {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Client detail: ${error.error.message || 'N/A'}`;
    } else {
      // server-side error
      errorMessage = `Server detail: ${error.error.exceptionMessage || 'N/A'}`;
    }

    return errorMessage;
  }

  getErrorReasonFromHttpStatus(err: any) {
    const httpError = err as HttpErrorResponse;
    const httpStatusCode = httpError.status;
    const errorStatus = `(Error code: ${httpStatusCode}.)`;
    if (httpStatusCode === 0) {
      return `Please check your internet connection then try again. ${errorStatus}`;
    }

    if (httpStatusCode === 504) {
      return `Please check your internet connection then try again. ${errorStatus}`;
    }

    if (httpStatusCode >= 500) {
      return `Server is updating, or has a fault. Please try again in a few minutes then contact support. ${errorStatus}`;
    }

    if (httpStatusCode === 409) {
      return `Your copy of this data has been updated elsewhere. Please refresh this page. ${errorStatus}`;
    }

    if (httpStatusCode === 401) {
      return `Your login session has expired. Please log in again to continue. ${errorStatus}`;
    }

    if (httpStatusCode === 400) {
      return `Please check your input and try again. Find and fix any error messages under each input on the page. ${errorStatus}`;
    }

    return `Please check your internet connection then try again. ${errorStatus}`;
  }
}
